















































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import CircledTitle from '@/components/CircledTitle.vue'
import Template from '../../mixins/Template.vue'
import { shuffle, take } from 'lodash'

@Component({
  name: 'image-grid',
  components: {
    CircledTitle
  }
})
export default class ImageGrid extends Mixins(Template) {
  /**
   * Get list of images.
   */
  get images() {
    return this.slide.images
  }
}
